export const USER_IDS = {
  mapsUnauthorized: 'maps-unauthorized',
  mapsFrameUnauthorized: 'maps-frame-unauthorized',
  mapsClient: 'maps-client',
  mapsRegional: 'maps-regional',
  mapsRegionalMimicClient: 'maps-regional-mimic-client',
  mapsAgentMimicClient: 'maps-agent-mimic-client'
} as const;

export const USER_RESPONSE_ERRORS = {
  blockedUser: 'SRV000000211'
};

export const AUTH_URL_PATH = 'Authorization/Token';
export const AUTH_BY_IDENTITY_TOKEN_URL_PATH = 'IdentityAuthorization/Token';
export const CROSS_ORIGIN_MESSAGE_TYPES = {
  token: 'token',
  contourType: 'contourType'
};
